/* NASIOL ROMÂNIA — interacțiuni temă */
(function () {
  'use strict';
  var cfg = window.nslConfig || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = cfg.moneyFormat || '{{amount_with_comma_separator}} lei';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDots + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDots)
      .replace(/\{\{\s*amount\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  }

  /* ---------- antet ---------- */
  var header = $('.nsl-header');
  if (header) {
    // antetul se ascunde când derulezi în jos și revine imediat ce urci puțin
    var bar = header.closest('.shopify-section') || header;
    bar.classList.add('nsl-hdr');
    var lastY = window.scrollY, ticking = false;
    var busy = function () {
      return document.querySelector('.nsl-drawer.is-open, #nsl-search.is-open') || header.contains(document.activeElement);
    };
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      if (Math.abs(y - lastY) > 6) {
        var hide = y > lastY && y > bar.offsetHeight + 160 && !busy();
        bar.classList.toggle('is-hidden', hide);
        document.documentElement.classList.toggle('nsl-hdr-off', hide);
        lastY = y;
      }
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }
  $$('[data-nsl-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var box = $('#nsl-search');
      if (!box) return;
      var open = box.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open);
      if (open) { var i = $('input', box); if (i) i.focus(); }
    });
  });

  /* ---------- sertare ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = $('[data-nsl-close]', d); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-nsl-open]');
    if (o) { e.preventDefault(); if (o.getAttribute('data-nsl-open') === 'nsl-cart') { refreshCart(); } openDrawer(o.getAttribute('data-nsl-open')); return; }
    var c = e.target.closest('[data-nsl-close]');
    if (c) { var d = c.closest('.nsl-drawer'); if (d) closeDrawer(d); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { $$('.nsl-drawer.is-open').forEach(closeDrawer); }
  });

  /* ---------- hero ---------- */
  $$('[data-nsl-hero]').forEach(function (hero) {
    var track = $('.nsl-hero__track', hero);
    var slides = $$('.nsl-hero__slide', hero);
    var dots = $$('.nsl-hero__dot', hero);
    if (slides.length < 2) return;
    var speed = parseInt(hero.getAttribute('data-speed') || '6', 10) * 1000;
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i); });
    }
    function play() { clearInterval(timer); if (speed > 0) timer = setInterval(function () { go(i + 1); }, speed); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    var prev = $('[data-nsl-prev]', hero), next = $('[data-nsl-next]', hero);
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / track.clientWidth);
      if (n !== i) { i = n; dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); }
    }, { passive: true });
    hero.addEventListener('mouseenter', function () { clearInterval(timer); });
    hero.addEventListener('mouseleave', play);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
  });

  /* ---------- contor (slide Black Friday) ---------- */
  $$('[data-nsl-countdown]').forEach(function (box) {
    var raw = box.getAttribute('data-nsl-countdown').trim();
    // fără fus orar în setare: ora României (EET, iarna)
    if (!/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) raw += '+02:00';
    var end = Date.parse(raw);
    if (isNaN(end)) return;
    var el = { d: $('[data-d]', box), h: $('[data-h]', box), m: $('[data-m]', box), s: $('[data-s]', box) };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { box.hidden = true; clearInterval(t); return; }
      box.hidden = false;
      el.d.textContent = pad(Math.floor(left / 86400));
      el.h.textContent = pad(Math.floor(left % 86400 / 3600));
      el.m.textContent = pad(Math.floor(left % 3600 / 60));
      el.s.textContent = pad(left % 60);
    }
    var t = setInterval(tick, 1000);
    tick();
  });

  /* ---------- tab-uri ---------- */
  $$('[data-nsl-tabs]').forEach(function (wrap) {
    var tabs = $$('[role="tab"]', wrap);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on);
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      });
    });
  });

  /* ---------- apariție la derulare ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.nsl-reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.nsl-reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- coș ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'nsl-toast nsl'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }
  function setCount(n) {
    $$('[data-nsl-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
    $$('.js-cart-count').forEach(function (el) { el.textContent = n; });
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderCart(cart) {
    setCount(cart.item_count);
    var box = $('[data-nsl-cart-body]');
    if (!box) return;
    var free = cfg.freeShipping || 0;
    var ship = $('[data-nsl-cart-ship]');
    if (ship && free) {
      var left = free - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price / free * 100));
      ship.innerHTML = (left > 0
        ? 'Mai adaugă <b>' + money(left) + '</b> și ai <b>livrare gratuită</b>.'
        : '<b>Ai livrare gratuită</b> pentru această comandă.') + '<div class="nsl-cart__bar"><i style="width:' + pct + '%"></i></div>';
    }
    if (!cart.items.length) {
      box.innerHTML = '<div class="nsl-cart__empty"><p>Coșul tău este gol.</p><a class="nsl-btn nsl-btn--black" href="' + (cfg.allUrl || '/collections/all') + '">Vezi produsele</a></div>';
      var f = $('[data-nsl-cart-foot]'); if (f) f.hidden = true;
      return;
    }
    box.innerHTML = cart.items.map(function (it, idx) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
      return '<div class="nsl-cart__item">' +
        (img ? '<img src="' + img + '" alt="" width="76" height="76" loading="lazy">' : '<span></span>') +
        '<div><b><a href="' + it.url + '">' + esc(it.product_title) + '</a></b>' + variant +
        '<div class="nsl-cart__qty"><button type="button" aria-label="Scade cantitatea" data-line="' + (idx + 1) + '" data-q="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button type="button" aria-label="Crește cantitatea" data-line="' + (idx + 1) + '" data-q="' + (it.quantity + 1) + '">+</button></div></div>' +
        '<div><div class="nsl-cart__price">' + money(it.final_line_price) + '</div><button type="button" class="nsl-cart__remove" data-line="' + (idx + 1) + '" data-q="0">Șterge</button></div>' +
        '</div>';
    }).join('');
    var foot = $('[data-nsl-cart-foot]');
    if (foot) { foot.hidden = false; var t = $('[data-nsl-cart-total]', foot); if (t) t.textContent = money(cart.total_price); }
  }
  function refreshCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nsl-cart-body] [data-line]');
    if (!b) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(b.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(b.getAttribute('data-q'), 10)) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  function addToCart(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1600); }
        return refreshCart().then(function () {
          if (cfg.openCartOnAdd !== false && document.getElementById('nsl-cart')) openDrawer('nsl-cart');
          else toast('Produsul a fost adăugat în coș');
        });
      })
      .catch(function (err) {
        if (btn) btn.classList.remove('is-loading');
        toast((err && (err.description || err.message)) || 'Nu am putut adăuga produsul. Încearcă din nou.');
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-nsl-add]');
    if (!b) return;
    e.preventDefault();
    addToCart([{ id: parseInt(b.getAttribute('data-nsl-add'), 10), quantity: 1 }], b);
  });
  $$('form[data-nsl-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = parseInt(form.querySelector('[name="id"]').value, 10);
      var q = form.querySelector('[name="quantity"]');
      addToCart([{ id: id, quantity: q ? Math.max(1, parseInt(q.value, 10) || 1) : 1 }], form.querySelector('[type="submit"]'));
    });
  });

  /* ---------- pagina de produs ---------- */
  $$('[data-nsl-pdp]').forEach(function (pdp) {
    var slides = $$('.nsl-gallery__slide', pdp);
    var thumbs = $$('.nsl-gallery__thumb', pdp);
    var cur = 0;
    function show(n) {
      if (!slides.length) return;
      cur = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === cur); });
      var c = $('[data-nsl-gcur]', pdp); if (c) c.textContent = cur + 1;
      if (thumbs[cur] && thumbs[cur].scrollIntoView && thumbs[cur].parentNode.scrollWidth > thumbs[cur].parentNode.clientWidth) {
        thumbs[cur].parentNode.scrollTo({ left: thumbs[cur].offsetLeft - 16, behavior: 'smooth' });
      }
      vsync();
    }

    // Video din galerie: rulează fără sunet doar cât e pe ecran (pe telefon doar slide-ul activ).
    var vids = $$('.nsl-gallery__video', pdp), seen = new Map();
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function vsync() {
      vids.forEach(function (v) {
        var s = v.closest('.nsl-gallery__slide');
        var shown = s.classList.contains('is-active') || getComputedStyle(s).position === 'relative';
        if (shown && seen.get(v) && !calm) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }
    if (vids.length) {
      if (calm) vids.forEach(function (v) { v.controls = true; });
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (es) { es.forEach(function (en) { seen.set(en.target, en.isIntersecting); }); vsync(); }, { threshold: 0.4 });
        vids.forEach(function (v) { vio.observe(v); });
      } else { vids.forEach(function (v) { seen.set(v, true); }); vsync(); }
      window.addEventListener('resize', vsync);
      $$('[data-nsl-sound]', pdp).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.parentNode.querySelector('video'), on = v.muted;
          vids.forEach(function (x) { x.muted = true; });
          $$('[data-nsl-sound]', pdp).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); x.setAttribute('aria-label', 'Pornește sunetul'); });
          v.muted = !on;
          b.setAttribute('aria-pressed', on); b.setAttribute('aria-label', on ? 'Oprește sunetul' : 'Pornește sunetul');
          if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      });
    }
    var gm = $('[data-nsl-gmain]', pdp), x0 = null;
    if (gm && slides.length > 1) {
      gm.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      gm.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
      });
    }

    var desc = $('[data-nsl-desc]', pdp);
    if (desc) {
      var body = $('.nsl-desc__body', desc), tg = $('[data-nsl-desc-toggle]', desc);
      var fit = function () { if (!desc.classList.contains('is-open') && body.scrollHeight <= body.clientHeight + 40) desc.classList.add('is-short'); };
      fit(); window.addEventListener('load', fit);
      tg.addEventListener('click', function () {
        var o = desc.classList.toggle('is-open');
        tg.setAttribute('aria-expanded', o);
        $('span', tg).textContent = o ? 'Arată mai puțin' : 'Citește toată descrierea';
        if (!o) desc.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var gp = $('[data-nsl-gprev]', pdp), gn = $('[data-nsl-gnext]', pdp);
    if (gp) gp.addEventListener('click', function () { show(cur - 1); });
    if (gn) gn.addEventListener('click', function () { show(cur + 1); });

    var q = $('[name="quantity"]', pdp);
    // oferta la cantitate: treapta aleasă setează cantitatea, iar cantitatea scrisă de mână bifează cea mai mare treaptă atinsă
    var qb = $('[data-nsl-qb]', pdp);
    var qbOpts = qb ? $$('input[name="nsl-qb"]', qb) : [];
    function qbSync() {
      if (!qb) return;
      var n = parseInt(q.value, 10) || 1, best = qbOpts[0];
      qbOpts.forEach(function (o) { if (parseInt(o.value, 10) <= n) best = o; });
      best.checked = true;
    }
    function qbPrices(price) {
      if (!qb) return;
      qb.setAttribute('data-price', price);
      qbOpts.forEach(function (o) {
        var lbl = o.closest('.nsl-qb__opt'), full = price * parseInt(o.value, 10), pct = parseInt(o.getAttribute('data-pct'), 10);
        $('[data-nsl-qb-now]', lbl).textContent = money(Math.floor(full * (100 - pct) / 100));
        var old = $('[data-nsl-qb-old]', lbl); if (old) old.textContent = money(full);
      });
    }
    qbOpts.forEach(function (o) { o.addEventListener('change', function () { q.value = o.value; }); });
    if (q) q.addEventListener('input', qbSync);
    $$('[data-nsl-step]', pdp).forEach(function (b) {
      b.addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-nsl-step'), 10)); qbSync(); });
    });

    var dataEl = $('[data-nsl-variants]', pdp);
    if (dataEl) {
      var variants = JSON.parse(dataEl.textContent);
      var idInput = $('[name="id"]', pdp);
      $$('.nsl-variant input', pdp).forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = $$('.nsl-variant', pdp).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
          var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); });
          if (!v) return;
          idInput.value = v.id;
          var lbl = inp.closest('.nsl-variant').querySelector('legend span'); if (lbl) lbl.textContent = inp.value;
          $$('[data-nsl-price]', pdp).forEach(function (p) { p.textContent = money(v.price); });
          qbPrices(v.price);
          var o = $('[data-nsl-compare]', pdp);
          if (o) { o.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
          var u = $('[data-nsl-unit]', pdp);
          if (u) u.textContent = v.unit_price ? money(v.unit_price) + ' / ' + (v.unit_price_measurement ? (v.unit_price_measurement.reference_value === 1 ? '' : v.unit_price_measurement.reference_value) + v.unit_price_measurement.reference_unit : '') : '';
          var btn = $('[data-nsl-atc]', pdp);
          if (btn) { btn.disabled = !v.available; btn.querySelector('span').textContent = v.available ? btn.getAttribute('data-label') : 'Stoc epuizat'; }
          if (v.featured_media) {
            var k = slides.findIndex(function (s) { return s.getAttribute('data-media') == v.featured_media.id; });
            if (k > -1) show(k);
          }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    }

    var sticky = $('.nsl-sticky');
    var atc = $('[data-nsl-atc]', pdp);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(atc);
      var sb = $('button', sticky);
      if (sb) sb.addEventListener('click', function () { atc.click(); });
    }
  });

  /* ---------- recomandări (încărcate după pagină) ---------- */
  $$('[data-nsl-reco]').forEach(function (box) {
    if (box.querySelector('.nsl-card')) return;
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var fresh = d.querySelector('[data-nsl-reco]');
      if (fresh && fresh.querySelector('.nsl-card')) { box.innerHTML = fresh.innerHTML; box.hidden = false; }
    }).catch(function () {});
  });

  /* ---------- carusel produse ---------- */
  $$('.nsl-rail--x').forEach(function (rail) {
    var sec = rail.closest('section');
    var prev = $('[data-nsl-rail-prev]', sec), next = $('[data-nsl-rail-next]', sec);
    function step() { var c = rail.querySelector('.nsl-card'); return c ? (c.offsetWidth + 16) * Math.max(1, Math.floor(rail.clientWidth / c.offsetWidth)) : rail.clientWidth; }
    function sync() {
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- colecție ---------- */
  $$('[data-nsl-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', s.value);
      window.location.href = url.toString();
    });
  });
  // Câmpurile goale (ex. prețul necompletat) nu se trimit, altfel filtrează „0 – 0 lei”.
  $$('[data-nsl-filters]').forEach(function (f) {
    f.addEventListener('submit', function () {
      $$('input', f).forEach(function (i) { if (i.type !== 'checkbox' && i.value === '') i.disabled = true; });
    });
  });
  $$('[data-nsl-filters] input[type="checkbox"]').forEach(function (c) {
    c.addEventListener('change', function () { c.form.requestSubmit ? c.form.requestSubmit() : c.form.submit(); });
  });
  $$('[data-nsl-filter-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = $('.nsl-filters');
      if (f) { var o = f.classList.toggle('is-open'); b.setAttribute('aria-expanded', o); }
    });
  });


  // Coloana de cumpărare urmează galeria; dacă e mai înaltă decât ecranul, se oprește cu partea de jos vizibilă.
  var stick = document.querySelector('[data-nsl-stick]');
  if (stick) {
    var setStick = function () {
      var h = stick.offsetHeight, top = Math.min(96, window.innerHeight - h - 24);
      stick.style.setProperty('--nsl-stick', top + 'px');
    };
    setStick();
    window.addEventListener('resize', setStick);
    if ('ResizeObserver' in window) new ResizeObserver(setStick).observe(stick);
  }


  // Căutare în lista de membri
  var mq = document.querySelector('[data-nsl-members-q]');
  if (mq) {
    var items = document.querySelectorAll('[data-nsl-members] [data-q]'), empty = document.querySelector('[data-nsl-members-empty]');
    var norm = function (v) { return v.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); };
    mq.addEventListener('input', function () {
      var q = norm(mq.value.trim()), n = 0;
      items.forEach(function (li) { var ok = !q || norm(li.getAttribute('data-q')).indexOf(q) > -1; li.hidden = !ok; if (ok) n++; });
      if (empty) empty.hidden = n > 0;
    });
  }

  if (document.getElementById('nsl-cart')) refreshCart();
})();
